import { useState } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
  Typography,
  styled,
} from "@mui/material"
import { AUTH_PROVIDER_KEY } from "../../utils/auth"
import type { AuthProvider } from "../../utils/auth"
import { extraColors } from "../../utils/theme"

const InfoItem = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}))

export const AuthProviderSelector = () => {
  const [confirmProvider, setConfirmProvider] = useState<AuthProvider | null>(
    null
  )

  const raw = localStorage.getItem(AUTH_PROVIDER_KEY)
  const currentProvider: AuthProvider =
    raw === "auth0" || raw === "keycloak" ? raw : "auth0"

  const handleProviderChange = (newProvider: AuthProvider) => {
    if (newProvider !== currentProvider) {
      setConfirmProvider(newProvider)
    }
  }

  const handleConfirm = () => {
    if (confirmProvider) {
      localStorage.setItem(AUTH_PROVIDER_KEY, confirmProvider)
      window.location.reload()
    }
  }

  return (
    <InfoItem>
      <Typography variant="small1" color={extraColors.medium}>
        Authentication Provider
      </Typography>
      <Select
        size="small"
        value={currentProvider}
        onChange={e => handleProviderChange(e.target.value as AuthProvider)}
        sx={{ width: "fit-content" }}
      >
        <MenuItem value="auth0">Auth0</MenuItem>
        <MenuItem value="keycloak">Keycloak</MenuItem>
      </Select>
      <Typography variant="caption" color={extraColors.medium}>
        PHC internal only. If locked out, navigate to{" "}
        <code>?auth_provider=auth0</code> to reset.
      </Typography>
      <Dialog
        open={confirmProvider !== null}
        onClose={() => setConfirmProvider(null)}
      >
        <DialogTitle>Switch Authentication Provider</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Switching to{" "}
            <strong>
              {confirmProvider === "keycloak" ? "Keycloak" : "Auth0"}
            </strong>{" "}
            will reload the page and log you out. Continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmProvider(null)}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained">
            Switch &amp; Reload
          </Button>
        </DialogActions>
      </Dialog>
    </InfoItem>
  )
}
